export default __webpack_public_path__ + "static/media/Shadow of Zath.42cd16c2.jpg";